export class DashboardType {
    public readonly name: string;
    public readonly id: number;

    private constructor(name: string, id: number) {
        this.id = id;
        this.name = name;
    }

    public static HiringTeamManager = new DashboardType(
        "HiringTeamManager",
        10
    );
    public static HiringTeamMember = new DashboardType("HiringTeamMember", 20);
    public static None = new DashboardType("none", -1);

    public static asArray = () => [
        DashboardType.HiringTeamManager,
        DashboardType.HiringTeamMember,
    ];

    public static fromId = (id: number) => {
        const type = DashboardType.asArray().find(t => t.id === id);
        return type;
    };
}
